import React, { useEffect, useState } from 'react';

/**
 * InitializeAuth Component
 * 
 * Run this component once to initialize the authentication system
 * Creates:
 * 1. Super Admin (John from ZipperAgent)
 * 2. Sample Client 1 (XYZ Company - Peter)
 * 3. Sample Client 2 (ABC Company - Amanda)
 */

const InitializeAuth = ({ onComplete }) => {
  const [initialized, setInitialized] = useState(false);
  const [message, setMessage] = useState('Initializing authentication system...');

  useEffect(() => {
    initializeAuthSystem();
  }, []);

  const initializeAuthSystem = () => {
    try {
      // Check if super admin already exists
      const existingSuperAdmins = JSON.parse(localStorage.getItem('superAdmins') || '[]');
      
      if (existingSuperAdmins.length > 0) {
        setMessage('Authentication system already initialized ✓');
        setInitialized(true);
        setTimeout(() => {
          if (onComplete) onComplete();
        }, 1000);
        return;
      }

      // 1. Create Super Admin (John from ZipperAgent)
      const superAdmin = {
        id: 'sa_001',
        name: 'John (ZipperAgent Support)',
        email: 'john@zipperagent.com',
        password: 'admin123',
        createdAt: new Date().toISOString()
      };

      localStorage.setItem('superAdmins', JSON.stringify([superAdmin]));

      // 2. Create Sample Clients
      const clients = [
        {
          id: 'client_001',
          companyName: 'XYZ Company',
          ownerName: 'Peter',
          ownerEmail: 'peter@xyzcompany.com',
          ownerPhone: '+1 (555) 123-4567',
          companyAddress: '123 Main St, New York, NY 10001',
          createdAt: new Date().toISOString(),
          createdBy: 'System',
          status: 'active',
          totalUsers: 3
        },
        {
          id: 'client_002',
          companyName: 'ABC Company',
          ownerName: 'Amanda',
          ownerEmail: 'amanda@abccompany.com',
          ownerPhone: '+1 (555) 987-6543',
          companyAddress: '456 Oak Ave, Los Angeles, CA 90001',
          createdAt: new Date().toISOString(),
          createdBy: 'System',
          status: 'active',
          totalUsers: 3
        }
      ];

      localStorage.setItem('clients', JSON.stringify(clients));

      // 3. Create Client Users
      const clientUsers = [
        // XYZ Company Users
        {
          id: 'user_001',
          name: 'Peter',
          email: 'peter@xyzcompany.com',
          password: 'password123',
          role: 'account_owner',
          clientId: 'client_001',
          companyName: 'XYZ Company',
          phone: '+1 (555) 123-4567',
          createdAt: new Date().toISOString(),
          createdBy: 'System'
        },
        {
          id: 'user_002',
          name: 'Sarah (XYZ Admin)',
          email: 'sarah@xyzcompany.com',
          password: 'password123',
          role: 'admin',
          clientId: 'client_001',
          companyName: 'XYZ Company',
          phone: '+1 (555) 123-4568',
          createdAt: new Date().toISOString(),
          createdBy: 'Peter'
        },
        {
          id: 'user_003',
          name: 'Mike (XYZ Agent)',
          email: 'mike@xyzcompany.com',
          password: 'password123',
          role: 'user',
          clientId: 'client_001',
          companyName: 'XYZ Company',
          phone: '+1 (555) 123-4569',
          createdAt: new Date().toISOString(),
          createdBy: 'Sarah'
        },
        
        // ABC Company Users
        {
          id: 'user_004',
          name: 'Amanda',
          email: 'amanda@abccompany.com',
          password: 'password123',
          role: 'account_owner',
          clientId: 'client_002',
          companyName: 'ABC Company',
          phone: '+1 (555) 987-6543',
          createdAt: new Date().toISOString(),
          createdBy: 'System'
        },
        {
          id: 'user_005',
          name: 'Tom (ABC Admin)',
          email: 'tom@abccompany.com',
          password: 'password123',
          role: 'admin',
          clientId: 'client_002',
          companyName: 'ABC Company',
          phone: '+1 (555) 987-6544',
          createdAt: new Date().toISOString(),
          createdBy: 'Amanda'
        },
        {
          id: 'user_006',
          name: 'Lisa (ABC Agent)',
          email: 'lisa@abccompany.com',
          password: 'password123',
          role: 'user',
          clientId: 'client_002',
          companyName: 'ABC Company',
          phone: '+1 (555) 987-6545',
          createdAt: new Date().toISOString(),
          createdBy: 'Tom'
        }
      ];

      localStorage.setItem('clientUsers', JSON.stringify(clientUsers));

      setMessage('Authentication system initialized successfully! ✓');
      setInitialized(true);

      // Display credentials in console
      console.log('%c═══════════════════════════════════════════════', 'color: #3b82f6; font-weight: bold');
      console.log('%cAUTHENTICATION SYSTEM INITIALIZED', 'color: #3b82f6; font-size: 18px; font-weight: bold');
      console.log('%c═══════════════════════════════════════════════', 'color: #3b82f6; font-weight: bold');
      console.log('');
      console.log('%c🛡️  SUPER ADMIN CREDENTIALS:', 'color: #dc2626; font-size: 16px; font-weight: bold');
      console.log('%cURL:', 'color: #10b981; font-weight: bold', window.location.origin + '/super-admin-login');
      console.log('%cEmail:', 'color: #10b981; font-weight: bold', superAdmin.email);
      console.log('%cPassword:', 'color: #10b981; font-weight: bold', superAdmin.password);
      console.log('');
      console.log('%c👔 CLIENT ACCOUNTS:', 'color: #3b82f6; font-size: 16px; font-weight: bold');
      console.log('');
      console.log('%cXYZ Company - Peter (Account Owner):', 'color: #f59e0b; font-weight: bold');
      console.log('%cEmail:', 'color: #10b981; font-weight: bold', 'peter@xyzcompany.com');
      console.log('%cPassword:', 'color: #10b981; font-weight: bold', 'password123');
      console.log('');
      console.log('%cXYZ Company - Sarah (Admin):', 'color: #3b82f6; font-weight: bold');
      console.log('%cEmail:', 'color: #10b981; font-weight: bold', 'sarah@xyzcompany.com');
      console.log('%cPassword:', 'color: #10b981; font-weight: bold', 'password123');
      console.log('');
      console.log('%cXYZ Company - Mike (User):', 'color: #6b7280; font-weight: bold');
      console.log('%cEmail:', 'color: #10b981; font-weight: bold', 'mike@xyzcompany.com');
      console.log('%cPassword:', 'color: #10b981; font-weight: bold', 'password123');
      console.log('');
      console.log('%cABC Company - Amanda (Account Owner):', 'color: #f59e0b; font-weight: bold');
      console.log('%cEmail:', 'color: #10b981; font-weight: bold', 'amanda@abccompany.com');
      console.log('%cPassword:', 'color: #10b981; font-weight: bold', 'password123');
      console.log('');
      console.log('%cABC Company - Tom (Admin):', 'color: #3b82f6; font-weight: bold');
      console.log('%cEmail:', 'color: #10b981; font-weight: bold', 'tom@abccompany.com');
      console.log('%cPassword:', 'color: #10b981; font-weight: bold', 'password123');
      console.log('');
      console.log('%cABC Company - Lisa (User):', 'color: #6b7280; font-weight: bold');
      console.log('%cEmail:', 'color: #10b981; font-weight: bold', 'lisa@abccompany.com');
      console.log('%cPassword:', 'color: #10b981; font-weight: bold', 'password123');
      console.log('');
      console.log('%c═══════════════════════════════════════════════', 'color: #3b82f6; font-weight: bold');

      // Redirect after 3 seconds
      setTimeout(() => {
        if (onComplete) onComplete();
      }, 3000);

    } catch (error) {
      console.error('Initialization error:', error);
      setMessage('Error initializing system. Check console.');
    }
  };

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      fontFamily: 'Inter, sans-serif',
      padding: '20px'
    }}>
      <div style={{
        background: '#ffffff',
        padding: '48px',
        borderRadius: '20px',
        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
        textAlign: 'center',
        maxWidth: '500px',
        width: '100%'
      }}>
        <div style={{
          width: '64px',
          height: '64px',
          border: '6px solid #e2e8f0',
          borderTopColor: '#3b82f6',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
          margin: '0 auto 24px'
        }}></div>
        <h2 style={{ 
          fontSize: '24px', 
          fontWeight: '700',
          color: '#1e293b',
          marginBottom: '12px'
        }}>
          {initialized ? '✓ System Ready!' : 'Setting Up Your CRM'}
        </h2>
        <p style={{ 
          fontSize: '16px', 
          color: '#64748b',
          marginBottom: '24px',
          lineHeight: '1.6'
        }}>
          {message}
        </p>
        {initialized && (
          <div style={{
            background: '#f0f9ff',
            border: '2px solid #bae6fd',
            borderRadius: '12px',
            padding: '20px',
            marginTop: '24px',
            textAlign: 'left'
          }}>
            <p style={{ 
              fontSize: '14px', 
              color: '#0369a1',
              margin: '0 0 12px 0',
              fontWeight: '600'
            }}>
              ✅ Created:
            </p>
            <ul style={{
              fontSize: '13px',
              color: '#0c4a6e',
              margin: 0,
              paddingLeft: '20px',
              lineHeight: '1.8'
            }}>
              <li>Super Admin (John)</li>
              <li>XYZ Company (Peter + 2 users)</li>
              <li>ABC Company (Amanda + 2 users)</li>
            </ul>
            <p style={{ 
              fontSize: '12px', 
              color: '#64748b',
              margin: '16px 0 0 0',
              fontStyle: 'italic'
            }}>
              Check console for login credentials
            </p>
          </div>
        )}
      </div>
      <style>{`
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default InitializeAuth;